import { AfterViewInit, Component, OnInit } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import * as fromRoot from '../store';
import { take } from 'rxjs/operators';

@Component({
    selector: 'ef-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css'],
    standalone: false
})
export class AboutComponent implements AfterViewInit {
    public environment = environment;
    public version$: Observable<string>;
    eFAACTApiVersion: string;
    eFAACTVersion = `${environment.version}-${environment.environment}`;
    constructor(private store: Store) {}
    ngAfterViewInit(): void {
        setTimeout(() => {
            this.version$ = this.store.pipe(
                select(fromRoot.Version.selectVersion)
            );
            this.version$.pipe(take(1)).subscribe(v => {
                this.eFAACTApiVersion = v;
            });
        }, 0);
    }
}
